import type { FetchArgs } from "@reduxjs/toolkit/query";

const KC_URLS = [
  process.env.CHANGE_PASSWORD_URL,
  process.env.MFA_RESET_URL,
  process.env.MFA_CONFIG_URL,
];

const isMSIQuery = (args: FetchArgs | string) => {
  if (
    (typeof args === "string" &&
      (args.startsWith("/api/") || KC_URLS.includes(args))) ||
    (typeof args !== "string" &&
      (args.url.startsWith("/api/") || KC_URLS.includes(args.url)))
  ) {
    return true;
  }
  return false;
};
export default isMSIQuery;
